







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DailyLoadStatusTypes } from '@/api/dashboard/DailyLoadStatusTypes';
import { DailyLoadStatusType } from '@/api/dashboard/DailyLoadStatusType';

@Component({})
export default class DailyLoadFileStatusIndicator extends Vue {
  @Prop() fileStatus!: DailyLoadStatusType;

  @Prop() expectedFileTime!: string;

  statusText() {
    switch (this.fileStatus) {
      case DailyLoadStatusType.FILES_RECEIVED_LATE:
      case DailyLoadStatusType.FILES_RECEIVED:
      case DailyLoadStatusType.SOME_FILES_RECEIVED:
        return DailyLoadStatusTypes.get(this.fileStatus);
      case DailyLoadStatusType.PAST_DUE:
      case DailyLoadStatusType.FILES_EXPECTED:
        return DailyLoadStatusTypes.get(this.fileStatus)?.replace('XX:XX', this.expectedFileTime);
      default:
        return this.fileStatus;
    }
  }

  statusColor() {
    switch (this.fileStatus) {
      case DailyLoadStatusType.FILES_RECEIVED:
        return 'primary';
      case DailyLoadStatusType.PAST_DUE:
        return 'error darken-1';
      default:
        return 'normal';
    }
  }

  statusTextColor() {
    switch (this.fileStatus) {
      case DailyLoadStatusType.FILES_RECEIVED:
      case DailyLoadStatusType.PAST_DUE:
        return 'white';
      default:
        return 'normal';
    }
  }
}
